<template>
  <v-container
    class="bg-white"
    width="60%">
    <v-card
      class="pa-5"
      variant="text">
      <v-card-item>
        <v-card-title>Zusammenfassung</v-card-title>
        <template #append>
          <v-fab
            elevation="0"
            icon="mdi-close"
            @click.prevent="$emit('close')"></v-fab>
        </template>
      </v-card-item>

      <v-card-text>
        <p>
          {{ $t("views.licence.review.monthlyCosts", { costs: monthlyCosts }) }}
        </p>
        <p v-if="yearlyCosts > 0">
          {{ $t("views.licence.review.yearlyCosts", { costs: yearlyCosts }) }}
        </p>
        <p v-if="chargeNeeded > 0">
          {{
            $t("views.licence.review.additionalCosts", {
              remainingDays: remainingDays
            })
          }}
          <template v-if="additionalCosts">
            {{ additionalCosts }}
          </template>
          <v-progress-circular
            :size="15"
            v-else
            indeterminate />
          <!-- <v-skeleton-loader
            v-else
            width="30px"
            type="text" /> -->
        </p>
        <v-data-table
          :headers="headers"
          :items="items"
          hide-default-footer></v-data-table>

        <p v-if="removed">
          <template v-if="private">
            {{ $t("views.licence.review.module-removed") }}
          </template>
          <template v-else>
            Entfernte Module können ohne Aufpreis noch bis zum Ende der
            Zahlungsperiode anderen Teammitgliedern zugewiesen werden.
          </template>
        </p>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          elevation="3"
          @click="emits('close')">
          Abbrechen
        </v-btn>
        <v-btn
          elevation="3"
          data-cy="licence-popup-save"
          @click="emits('save')"
          >Speichern</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script lang="ts" setup>
import { listModule } from "@/types/global";
import { useTranslation } from "i18next-vue";
import { computed } from "vue";

const { t } = useTranslation();
const emits = defineEmits(["close", "save"]);

const props = defineProps({
  private: {
    type: Boolean,
    required: false
  },
  monthlyCosts: {
    type: Number,
    required: true
  },
  yearlyCosts: {
    type: Number,
    required: true
  },
  remainingDays: {
    type: Number,
    required: true
  },
  additionalCosts: {
    type: Number,
    required: true
  },
  modulesRemoved: {
    type: Object,
    required: true
  },
  initialItems: {
    type: Array,
    required: true
  },
  items: {
    type: Array,
    required: true
  },
  chargeNeeded: {
    type: Number,
    required: true
  }
});

const headers = [
  { title: "Modul", key: "module" },
  { title: "Alte Anzahl", key: "oldQuantity" },
  { title: "Neue Anzahl", key: "newQuantity" }
];

const items = computed(() => {
  return props.initialItems.map((item: listModule, index) => {
    return {
      module: t("views.licence.modules." + item.name + ".name"),
      oldQuantity: item.slots,
      newQuantity: props.items[index]?.slots
    };
  });
});

const removed = computed(() => {
  return Object.values(props.modulesRemoved).filter((item) => item > 0).length;
});
</script>
